import type { IconData } from '@stacksjs/iconify-core'

export const bh1x1: IconData = {
  "body": "<path fill=\"#fff\" d=\"M0 0h512v512H0\"/><path fill=\"#ce1126\" d=\"M512 0H102.4l83.4 51.2l-83.4 51.2l83.4 51.2l-83.4 51.2l83.4 51.2l-83.4 51.2l83.4 51.2l-83.4 51.2l83.4 51.2l-83.4 51.2H512\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default bh1x1
